// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from '@/theme/css';
// hooks
import { useMockedUser } from '@/hooks/auth/use-mocked-user';
// components
import Logo from '@/components/media/logo';
import { NavSectionMini } from '@/components/navigation/nav-section';
//
import { useSettingsContext } from '@/components/layout/settings';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useMockedUser();
  const settings = useSettingsContext();
  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 20,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          backgroundColor: (theme) =>
            settings.themeMode === 'light' ? theme.palette.background.neutral : '#161C24',
          borderRight: (theme) => `solid 0.5px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', mb: 1.5, mt: 2 }} />

        <NavSectionMini
          data={navData}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
      </Stack>
    </Box>
  );
}
